<template>
  <div class="row justify-content-center">
    <div class="col col-sm-4">
      <div class="alert alert-success text-dark h3 mt-3 fw-bold">
        <p class="m-0">Completed!</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompletionAlert"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
